import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class RaceLiveUpdateStore extends LocalModel {
    constructor() {
        super('raceLiveUpdate', {
            namePlural: 'raceLiveUpdates',
            namePluralReal: 'raceliveupdates',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/raceliveupdates/',
                    params: {
                        limit: 50,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/raceliveupdates/',
                    params: {},
                },
                save: {
                    url: '/api/raceliveupdates/',
                    params: {},
                },
                delete: {
                    url: '/api/raceliveupdates/',
                    params: {},
                },
            },
        });
    }

    @observable newRaceLiveUpdate = {};

    @observable raceLiveUpdate = {};

    @observable raceLiveUpdates = [];
}

const store = new RaceLiveUpdateStore();
export default store;
